<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量">
                            </m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="产品信息">
                            <c-input name="product_info"></c-input>
                        </m-search-item>
                        <m-search-item label="采购人">
                            <c-input name="purchase_user_name"></c-input>
                        </m-search-item>
                        <m-search-item label="验机人">
                            <c-input name="quality_user_name"></c-input>
                        </m-search-item>
                        <m-search-item label="等级">
                            <c-select :options="LEVEL_TYPE" name="level_type"></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>
                <template #operate>
                    <c-button v-if="auth('b_high_stock_age_export')" prepend-icon="tf-export"
                              @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <template #produce_info="{data}">
                    <m-product-info :name="data.produce_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>
                <!--等级-->
                <template #level_type="{data}">
                    <c-state tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                </template>
                <!--背贴码主状态-->
                <template #main_state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_MAIN_STATE" :value="data.main_state"></c-state>
                </template>
                <!--背贴码详细状态-->
                <template #state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_STATE" :value="data.state"></c-state>
                </template>
                <!--采购价-->
                <template #purchase_price="{data}">
                    ￥{{data.purchase_price}}
                </template>
                <!--维修费-->
                <template #repair_cost="{data}">
                    ￥{{data.repair_cost}}
                </template>
                <!--是否拆机-->
                <template #is_dismantle="{data}">
                    <c-state tag async dict="IS_DISMANTLE" :value="data.is_dismantle"></c-state>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="150"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_high_stock_age_remark_view')" icon="tf-detail" @click="showRemark(data)">查看备注</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--查看备注弹窗-->
            <code-remark ref="codeRemark"></code-remark>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'
import codeRemark from "@/pages/storage/code_remark.vue";

export default {
    name: 'm_high_stock_age',

    components: {codeRemark},

    computed: {
        ...mapState(['saasInfo','userInfo']),

        ...asyncMapState(['LEVEL_TYPE'])
    },

    data() {
        return {
            defaultSearchData: {
            },
            workType: 24            //待入库商品列表
        }
    },
    methods: {
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },
        /****展示备注****/
        showRemark(data) {
            this.$refs.codeRemark.open(data);
        }
    }
}
</script>